import { render, staticRenderFns } from "./super_sidebar.vue?vue&type=template&id=c6304f4c&vue3"
import script from "./super_sidebar.vue?vue&type=script&lang=js&vue3"
export * from "./super_sidebar.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports